__webpack_require__.p = "/Crypto-Prices-Table/";